import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { states } from 'constants/DropdownsValues';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import PostingInfo from 'components/PostingInfo';
import * as action from 'components/DashboardView/actionTypes';
import moment from 'moment/moment';

import styles from './ListView.scss';
// to import local scss fle

const ListView = (props) => {
  const clickToRequest = () => {
    const { subscribed, onTrial } = props;
    const contactedCountMap = props.profile.get('contactedCount');
    let contactedCount;
    if (contactedCountMap) {
      contactedCount = contactedCountMap.toJS();
    }
    const counter = contactedCount.count; // eslint-disable-line
    // const undefinedCase = props.profile.get('contactedCount');
    const difference = moment().diff(contactedCount.lastContacted, 'hours');
    const req = {
      from_profile_id: props.profileId,
      posting_id: props.posting.get('id'),
      request_type: 'INTEREST',
      coach_name: props.posting.get('coach_name'),
      college_name: props.posting.get('college_name'),
      college_image: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png',
      city: props.posting.get('city'),
      division: props.posting.get('division'),
      college_id: props.posting.get('college_id') ? props.posting.get('college_id') : 'college_id',
      sa_name: props.fullname,
      sa_state: states[props.state],
      sa_preference: props.position_pref,
      sa_school: props.school,
      sa_city: props.city,
      sa_image: props.sa_image,
      sa_email: props.sa_email,
      year_of_graduation: props.year_of_graduation,
      team_page_link: props.posting.get('team_page_link'),
      question_link: props.posting.get('question_link'),
      sa_twitter: ((props.profile.get('sa_twitter') !== undefined) && (props.profile.get('sa_twitter') !== null)) ? props.profile.get('sa_twitter').substring('https://twitter.com/'.length) : '',
      sa_height: props.profile.get('height'),
      sa_weight: props.profile.get('weight'),
      sa_t40: props.t40,
      request_views: props.requestViewedCount,
    };
    let maxCount = 1;
    if (subscribed || onTrial) {
      maxCount = 10;
    }
    if (counter < maxCount || contactedCountMap === undefined) {
      const payload = {
        student_profile_id: props.profileId,
        college_id: props.posting.get('college_id'),
        type_of_list: 'CONTACTED',
      };
      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');

      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
      props.showSnackBar('Added to contacted list, will keep you informed.');
    } else if (counter >= maxCount && difference >= 23) {
      const payload = {
        student_profile_id: props.profileId,
        college_id: props.posting.get('college_id'),
        type_of_list: 'CONTACTED',
      };
      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
      props.showSnackBar('Added to contacted list, will keep you informed.');
    } else {
      props.showCounterScreen();
    }
  };

  return (
    <div className={cn('row', styles.container)}>
      <div className={cn('col s12', styles.listInBig)}>
        <span className={styles.absoluteHeart}><PostingInfo {...props} /></span>
        <div className={cn('col s5', styles.equalDivs)}>
          <div className={cn('col s2')}>
            <img className={styles.colgeIcon} src="https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png" alt="college-icon" />
          </div>
          <div className={cn('col s10', styles.textContainer)} >
            <span>
              <div className={styles.collegeName}>
                {/* eslint-disable*/}
                <a href={props.posting.get('team_page_link')} target="_blank">
                  {props.posting.get('college_name')}
                </a>
                  {/*eslint-enable*/}
              </div>
              <div className={styles.lightText}>{props.posting.get('city')}</div>
              <div className={styles.lightText}>{props.posting.get('state')}</div>
            </span>
          </div>
        </div>
        <div className={cn('col s3', styles.equalDivs)}>
          <div className={cn('col s12', styles.textContainer)} >
            <span>
              <div className={styles.positionHeader}>{props.posting.get('posting_title')}</div>
            </span>
          </div>
        </div>
        <div className={cn('col s1', styles.equalDivs)}>
          <div className={cn('col s12', styles.textContainer)} >
            <span>
              {/* <div className={styles.imageAndName}> */}
              {/* <img className={styles.icon} src="https://media.dev.myrecruitboard.com/Images/userIcon.png" alt="icon" /> */}
              {/* {props.posting.get('coach_name')} */}
              {/* </div> */}
            </span>
          </div>
        </div>
        <div className={cn('col s3', styles.equalDivs)}>
          <div className={styles.buttonContainer}>
            <span>
              {props.interested ? <button className={styles.interested}>
                INTERESTED
              </button>
                  :
              <button className={styles.respond} onClick={clickToRequest}>CONTACT COACH</button>
              }
            </span>
          </div>
        </div>
      </div>
      <div className={cn('col s12', styles.listInSmall)}>
        <div className={cn('col s3', styles.firstDiv)}>
          <img className={styles.colgeIcon} src="https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png" alt="college-icon" />
        </div>
        <div className={cn('col s9', styles.equalDivs)}>
          <div className={cn('col s12', styles.textContainer)} >
            <span>
              <div className={styles.collegeName}>
                {/* eslint-disable*/}
                <a href={props.posting.get('team_page_link')} target="_blank">
                  {props.posting.get('college_name')}
                </a>
                  {/*eslint-enable*/}
              </div>
              <div className={styles.lightText}>{props.posting.get('city')}</div>
              <div className={styles.lightText}>{props.posting.get('state')}</div>
              <div className={styles.positionHeader}>{props.posting.get('posting_title')}</div>
            </span>
          </div>
          <span className={styles.absoluteHeart}><PostingInfo {...props} /></span>
        </div>
        <div className={cn('col s12', styles.smallButtonContainer)}>
          <span>
            {props.interested ? <button className={styles.interested}>
                    INTERESTED
                  </button>
                  :
            <button className={styles.respond} onClick={clickToRequest}>CONTACT COACH</button>
              }
          </span>
        </div>
      </div>
    </div>
  );
};
{ /* eslint-disable */} // eslint-disable-line
ListView.propTypes = {
  posting: PropTypes.shape().isRequired,
  addToRequest: PropTypes.func.isRequired,
  addToList: PropTypes.func.isRequired,
  interested: PropTypes.bool,
  profileId: PropTypes.string.isRequired,
  fullname: PropTypes.string.isRequired,
  position_pref: PropTypes.string.isRequired,
  school: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  sa_image: PropTypes.string.isRequired,
  showSnackBar: PropTypes.func.isRequired,
  state: PropTypes.string.isRequired,
  sa_email: PropTypes.string.isRequired,
  footballTeamPage: PropTypes.string.isRequired,
  questionAireLink: PropTypes.string.isRequired,
  showCounterScreen: PropTypes.func.isRequired,
  profile: PropTypes.shape.isRequired,
  year_of_graduation: PropTypes.string.isRequired,
  requestViewedCount: PropTypes.number.isRequired,
  t40: PropTypes.string.isRequired,
};
{/* eslint-enable */ }
ListView.defaultProps = {
  interested: false,
};

export default ListView;



// WEBPACK FOOTER //
// ./src/components/ListView/ListView.js